import { render } from "./indextwoclinic.vue?vue&type=template&id=4c2f810e"
import script from "./indextwoclinic.vue?vue&type=script&lang=js"
export * from "./indextwoclinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__